import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const LegalLayout = ({ eyebrow, title, updated, children, testId }) => (
  <section data-testid={testId} className="pb-24 pt-[120px] sm:pt-[150px]">
    <div className="mx-auto w-full max-w-3xl px-5 sm:px-8">
      <Reveal>
        <Link
          to="/"
          data-testid={`${testId}-back-link`}
          className="mb-8 inline-flex items-center gap-2 rounded-sm text-xs font-bold uppercase tracking-[0.18em] text-paper/40 transition-colors duration-200 hover:text-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lilac focus-visible:ring-offset-2 focus-visible:ring-offset-ink"
        >
          <ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />
          Back to home
        </Link>
        <Eyebrow testId={`${testId}-eyebrow`}>{eyebrow}</Eyebrow>
        <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-paper sm:text-5xl">{title}</h1>
        <p className="mt-3 text-sm text-paper/40">Last updated: {updated}</p>
        <div className="mt-12 space-y-10">{children}</div>
      </Reveal>
    </div>
  </section>
);

export const LegalSection = ({ title, children }) => (
  <div>
    <h2 className="font-display text-xl font-extrabold text-paper">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-paper/60">{children}</div>
  </div>
);
